import { useState, useEffect, useCallback } from "react";
import { getSectionToUserURL } from "../../utils/ConstantsURL";

export function useSections(token, idDocument) {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);

  const refresh = useCallback(() => {
    setRefreshIndex((prev) => prev + 1);
  }, []);

  useEffect(() => {
    if (!token || !idDocument) return;

    const fetchSections = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(getSectionToUserURL(idDocument), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Error desconocido");
        setSections(data);
      } catch (err) {
        console.error("useSections:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSections();
  }, [token, idDocument, refreshIndex]);

  return { sections, loading, error, refresh };
}
